import ViewApi from '@/api/ViewApi';
import store from '../store/index';
import router from '../router/index';

export default {
  async getAllCollectionPages(
    tenant: string,
    params: any = {}
  ): Promise<any[]> {
    if (!store.getters.loggedIn(Date.now())) {
      router.push('/login');
    }

    const views: any[] = [];
    const pageResponses = await ViewApi.getAllCollectionPages(tenant, params);

    pageResponses.forEach((response: any) => {
      response.data.data.forEach((userObj: any) => {
        views.push({
          uuid: userObj.id,
          description: userObj.attributes.description,
          entityType: userObj.attributes.entityType,
          requestType: userObj.attributes.requestType,
          requestConfig: userObj.attributes.requestConfig,
          createdAt: userObj.meta.createdAt,
          updatedAt: userObj.meta.updatedAt,
        });
      });
    });

    return views;
  },

  async getSingle(tenant: string, viewUUID: string): Promise<any> {
    if (!store.getters.loggedIn(Date.now())) {
      router.push('/login');
    }

    const response = await ViewApi.getSingle(tenant, viewUUID);

    return {
      uuid: response.data.data.id,
      description: response.data.data.attributes.description,
      entityType: response.data.data.attributes.entityType,
      requestType: response.data.data.attributes.requestType,
      requestConfig: response.data.data.attributes.requestConfig,
      createdAt: response.data.data.meta.createdAt,
      updatedAt: response.data.data.meta.updatedAt,
    };
  },

  async create(
    tenantUUID: string,
    description: string,
    entityType: string,
    requestType: string,
    requestConfig: any
  ): Promise<any> {
    if (!store.getters.loggedIn(Date.now())) {
      router.push('/login');
    }

    const response = await ViewApi.create(
      tenantUUID,
      description,
      entityType,
      requestType,
      requestConfig
    );

    if (response.data.data.type && response.data.data.type == 'views') {
      return {
        uuid: response.data.data.id,
        description: response.data.data.attributes.description,
        entityType: response.data.data.attributes.entityType,
        requestType: response.data.data.attributes.requestType,
        requestConfig: response.data.data.attributes.requestConfig,
        createdAt: response.data.data.meta.createdAt,
        updatedAt: response.data.data.meta.updatedAt,
      };
    } else {
      throw TypeError('Response not type views');
    }
  },

  async update(
    tenantUUID: string,
    viewUUID: string,
    description?: string,
    entityType?: string,
    requestType?: string,
    requestConfig?: any
  ): Promise<any> {
    if (!store.getters.loggedIn(Date.now())) {
      router.push('/login');
    }

    const response = await ViewApi.update(
      tenantUUID,
      viewUUID,
      description,
      entityType,
      requestType,
      requestConfig
    );

    if (response.data.data.type && response.data.data.type == 'views') {
      return {
        uuid: response.data.data.id,
        description: response.data.data.attributes.description,
        entityType: response.data.data.attributes.entityType,
        requestType: response.data.data.attributes.requestType,
        requestConfig: response.data.data.attributes.requestConfig,
        createdAt: response.data.data.meta.createdAt,
        updatedAt: response.data.data.meta.updatedAt,
      };
    } else {
      throw TypeError('Response not type views');
    }
  },

  async delete(tenantUUID: string, viewUUID: string): Promise<void> {
    if (!store.getters.loggedIn(Date.now())) {
      router.push('/login');
    }

    await ViewApi.delete(tenantUUID, viewUUID);
  },

  async getData(
    tenantUUID: string,
    viewUUID: string,
    params: any = {}
  ): Promise<any> {
    if (!store.getters.loggedIn(Date.now())) {
      router.push('/login');
    }

    const response = await ViewApi.getData(tenantUUID, viewUUID, params);
    return response.data;
  },
};
